import { useState } from "react";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup"
import axios from "../../../config/axios";
import baseURL from "../../../config/api";
import useAuth from "../../../hook/useAuth";
import { useNavigate } from "react-router-dom";

export const AddCourseCategory = () => {
    const { auth }: any = useAuth();
    const navigate = useNavigate();
    const [name, setName] = useState<string>("");
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);

        await axios
            .post(
                `${baseURL}courseCategories?userId=${auth?.id}`,
                JSON.stringify({
                    name,
                    orderNumber: 0,
                    createdAt: new Date().toLocaleString(),
                    createdBy: auth?.givenname,
                }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: false,
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }


    return (
        <>
            <div className="w-full p-4 bg-white rounded-md">
                <h2 className={`text-lg font-semibold`}>Add Category</h2>

                <div className="mt-2 p-2">
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className="w-full">

                            {/* Responsive Form Grid */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                {/* First Column */}
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-xs font-medium text-[#667085]">Name</label>
                                        <input
                                            type="text"
                                            className="w-full px-[8px] py-[8px] border rounded-md border-[#D0D0D0] outline-none focus:border-[#167AC3] text-sm text-[#1D2939] bg-transparent"
                                            value={name}
                                            placeholder="Name"
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>

                                </div>
                            </div>

                            {/* Buttons */}
                            <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                <button
                                    type="submit"
                                    className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                >
                                    Save
                                </button>
                                <button
                                    type="button"
                                    onClick={() => navigate(-1)}
                                    className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}